// Costanti condivise tra i componenti Settings

export const PROVIDERS = [
  { name: 'Gmail', imap_server: 'imap.gmail.com', imap_port: 993, smtp_server: 'smtp.gmail.com', smtp_port: 465, note: 'Richiede App Password con 2FA attiva (myaccount.google.com → Sicurezza → Password per le app).' },
  { name: 'Outlook', imap_server: 'outlook.office365.com', imap_port: 993, smtp_server: 'smtp-mail.outlook.com', smtp_port: 587, note: 'Usa la password Microsoft. Se usi autenticazione moderna, abilita IMAP da outlook.com → Impostazioni.' },
  { name: 'Yahoo', imap_server: 'imap.mail.yahoo.com', imap_port: 993, smtp_server: 'smtp.mail.yahoo.com', smtp_port: 465, note: 'Richiede App Password Yahoo (account.yahoo.com → Sicurezza → Password per app).' },
  { name: 'iCloud', imap_server: 'imap.mail.me.com', imap_port: 993, smtp_server: 'smtp.mail.me.com', smtp_port: 587, note: 'Richiede App Password Apple (appleid.apple.com → Sicurezza → Password per le app).' },
  { name: 'Libero', imap_server: 'imap.libero.it', imap_port: 993, smtp_server: 'smtp.libero.it', smtp_port: 465, note: 'Usa email e password Libero. Abilita accesso IMAP dal pannello web se necessario.' },
  { name: 'Aruba', imap_server: 'imap.aruba.it', imap_port: 993, smtp_server: 'smtp.aruba.it', smtp_port: 587, note: 'Email Aruba.it (casella professionale o business). Usa le credenziali webmail.' },
  { name: 'TIM/Alice', imap_server: 'imap.tim.it', imap_port: 993, smtp_server: 'smtp.tim.it', smtp_port: 587, note: 'Email TIM/Alice. Controlla pannello TIM se IMAP è abilitato.' },
  { name: 'Tiscali', imap_server: 'imap.tiscali.it', imap_port: 993, smtp_server: 'smtp.tiscali.it', smtp_port: 465, note: 'Email Tiscali.it. Usa le credenziali del pannello Tiscali.' },
  { name: 'Virgilio', imap_server: 'imap.virgilio.it', imap_port: 993, smtp_server: 'smtp.virgilio.it', smtp_port: 465, note: 'Email Virgilio/Matrix. Abilita accesso IMAP dal pannello web Virgilio.' },
  { name: 'Personalizzata', imap_server: '', imap_port: 993, smtp_server: '', smtp_port: 465, note: 'Inserisci manualmente le impostazioni IMAP/SMTP del tuo provider.' },
];

export const COLOR_PRESETS = [
  { color: '#6B6FD8', bg: '#EDE8FF' },
  { color: '#E87C5A', bg: '#FFEDE4' },
  { color: '#E85B7A', bg: '#FFE4EF' },
  { color: '#2DAA7E', bg: '#E4F7EE' },
  { color: '#4A90D9', bg: '#E4F0FF' },
  { color: '#F39C12', bg: '#FFF3E0' },
  { color: '#8E44AD', bg: '#F5E8FF' },
  { color: '#E74C3C', bg: '#FFE8E8' },
  { color: '#1ABC9C', bg: '#E0FAF4' },
  { color: '#7F8C8D', bg: '#F0F2F3' },
];

export const CONDITION_FIELDS = [
  { value: 'from_addr', label: 'Indirizzo mittente' },
  { value: 'from_domain', label: 'Dominio mittente' },
  { value: 'from_name', label: 'Nome mittente' },
  { value: 'subject', label: 'Oggetto' },
];

export const CONDITION_OPERATORS = [
  { value: 'contains', label: 'contiene' },
  { value: 'equals', label: 'è uguale a' },
  { value: 'starts_with', label: 'inizia con' },
  { value: 'ends_with', label: 'finisce con' },
];

export const inputClass = "w-full px-3 py-2 text-sm rounded-lg border focus:outline-none focus:ring-1 transition-all";
export const inputStyle = { borderColor: '#D9D2C8', background: 'white', '--tw-ring-color': '#E2725B', fontFamily: 'Manrope, sans-serif' };
